<template>
  <div>
    <el-dialog
      :title="title"
      width="1200px"
      class="dialog-wrap form-module"
      :visible.sync="addQuestion"
      :close-on-click-modal="false"
      :before-close="handleClose"
      :destroy-on-close="true"
      :close-on-press-escape="true"
    >
      <SchemeBaseInfo :PurchaseScheme="scheme"></SchemeBaseInfo>
      <div class="change_inform">
        <div class="title">
          新增问题
          <span style="color: orange">
            <img src="@/assets/img/icon_tips0.png" />
            请将问题汇总，并加盖公章后上传文件
          </span>
        </div>
        <el-form :inline="true" :model="ruleform" class="form_table" :rules="rules" ref="form" :inline-message="true">
          <el-form-item label="问题附件" class="allLine" prop="fileList">
            <el-upload
              :action="uploadUrl"
              :limit="uploadLimt"
              :before-remove="removeConfirm"
              :before-upload="beforeUpload"
              :on-remove="handleRemove"
              :on-change="fileChange"
              :on-exceed="exceedFile"
              :on-success="handleSuccess"
              :on-error="handleError"
              :auto-upload="false"
              :data="uploadData"
              accept=".pdf"
              ref="uploader"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="提问人" prop="questioner"><el-input v-model="ruleform.questioner" style="width: 200px"></el-input></el-form-item>
          <el-form-item label="联系电话" prop="mobile"><el-input v-model="ruleform.mobile" style="width: 200px"></el-input></el-form-item>
        </el-form>
        <el-row>
          <el-col :span="4" :offset="8">
            <div class="btn_wrap"><span class="btn_1 btn_reg" @click.stop="handleClose">取消</span></div>
          </el-col>
          <el-col :span="4"><span class="btn_1" style="width: 100%" @click.stop="fnSubmit">确认提交</span></el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SchemeBaseInfo from '@/views/Common/PurchaseScheme/SchemeBaseInfo.vue'
export default {
  components: { SchemeBaseInfo },
  props: {
    addQuestion: {
      type: Boolean,
      default: false
    },
    scheme: { type: Object },
    autoId: { type: String },
    schemeId: { type: String },
    uploadUrl: { type: String }
  },
  data() {
    return {
      title: '新增问题',
      uploadLimt: 100,
      rules: {
        questioner: [{ required: true, message: '请输入提问人', trigger: 'blur' }],
        mobile: [{ required: true, message: '请输入联系电话', trigger: 'blur' }]
      },
      ruleform: {
        fileList: [],
        questioner: '',
        mobile: '',
        schemeId: '',
        autoId: ''
      },
      uploadCount: 0,
      successCount: 0,
      uploadData: {}
    }
  },
  mounted() {
    console.log(this.schemeId)
    console.log(this.autoId)
    this.ruleform.schemeId = this.schemeId
    this.ruleform.autoId = this.autoId
    this.uploadData.loginToken = window.localStorage.getItem('loginToken')
  },
  methods: {
    handleClose() {
      this.$refs['form'].resetFields()
      this.$refs['uploader'].clearFiles()
      this.$emit('update:addQuestion', false)
    },
    exceedFile(files, fileList) {
      this.$message({
        showClose: true,
        message: `最多上传${this.uploadLimit}个文件`,
        type: 'warning'
      })
    },
    // 文件状态改变时的钩子
    fileChange(file, fileList) {
      console.log(file)
    },
    // 点击x时执行的钩子函数
    removeConfirm(file, fileList) {
      if (file.status == 'success') {
        return this.$confirm(`确定删除 ${file.name}？`)
      }
    },
    handleRemove(file, fileList) {},
    beforeUpload(file) {
      console.log(file)
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'pdf' || testmsg === 'PDF'
      // const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension) {
        this.$message({
          message: '上传文件只能是pdf格式!',
          type: 'warning'
        })
      }
      return extension
    },
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      console.log(response)
      if (response.errcode == 0) {
        this.ruleform.fileList.push(response.FileList[0].fileId)
        this.$notify.success({
          title: '上传结果',
          message: `${file.name}上传成功`,
          position: 'bottom-right'
        })
        this.successCount++
      } else {
        this.$notify.error({
          title: '上传结果',
          message: `${file.name}上传失败:${response.errmsg}`,
          position: 'bottom-right'
        })
      }
      this.uploadCount++
      if (this.uploadCount >= fileList.length) {
        if (this.successCount < fileList.length) {
          this.$message.error('终止保存，部分文件上传失败')
          return
        }
        this.fnSubmitForm()
      }
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      console.log(err)
      this.$notify.error({
        title: '上传结果',
        message: `${file.fileName}上传失败:${err}`,
        position: 'bottom-right'
      })
    },
    fnSubmit() {
      console.log(this.$refs['uploader'])
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.$refs['uploader'].uploadFiles.length == 0) {
            this.$message.warning('未选择问题附件')
            return false
          }
          this.uploadCount = 0
          this.successCount = 0

          this.$refs['uploader'].submit()
        }
      })
    },
    fnSubmitForm() {
      console.log(this.schemeId)
      console.log(this.autoId)
      console.log(this.ruleform)
      this.postRequest('/QuestionManage/SaveQuestion', { jsonStr: JSON.stringify(this.ruleform) }).then((res) => {
        if (res.data.errcode == 0) {
          this.$message.success('操作成功')
          this.handleClose()
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    }
  }
}
</script>

<style scoped>
.allLine {
  flex: 0 0 100% !important;
}
</style>
